import Vue from "vue";
import Router from "vue-router";
import RxMap from "./views/RxMap.vue";
import StateDetails from "./components/StateDetails.vue";
import NotFound from "./components/NotFound.vue";
Vue.use(Router);

export default new Router({
  routes: [
    { path: "/", component: RxMap },

    {
      path: "/map",
      name: "map",
      component: RxMap,
      children: [
        {
          path: ":isoCode/",
          name: "stateDetails",
          component: StateDetails
        }
      ]
    },
    { path: "/not-found", component: NotFound, name: "notFound" }
  ],
  scrollBehavior: function(to) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
